import Skeleton from '@material-ui/lab/Skeleton'

import { useStyles } from './styles/ChannelContainerSkeleton.styles'

type Props = {}

function ChannelContainerSkeleton({}: Props) {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <div className={classes.logoContainer}>
        <Skeleton animation="wave" className={classes.image} />
      </div>
      <div className={classes.nameContainer}>
        <Skeleton animation="wave" className={classes.skeleton} />
      </div>
    </div>
  )
}

export default ChannelContainerSkeleton
